import mock from '../mock'

// ** Third Party Components
import axios from 'axios'

// ** Utils
import { paginateArray } from '../utils'

// ** Utils
import { getUserData } from '@utils'

// ** Custom Components
import GetApiCOC from '../../@fake-db/ApiCOC'

const base64ToString = (response) => { 

  if (response.data.Result === "true" && response.data.response_data.length > 0) {
    return JSON.parse(Buffer.from(response.data.response_data, "base64").toString()) 
  } else {
    return []
  }
}

const getKpisList = async (dataOrigen, refrescar, api, token, body, config) => {

  const configws = {
    method: 'get',
    url:    api,
    headers: { 
      Accept:      'application/json',
      obrientoken: token
    },
    params: body
  }

  let data = dataOrigen

  if (data.kpis_list.length <= 0 || data.date_from !== config.startDate || data.date_to !== config.endDate) {
    const response = await axios(configws)
    data = {  kpis_list: base64ToString(response) }
  }

  // eslint-disable-next-line object-curly-newline
  //const { q = '', perPage = 10, page = 1, sort, sortColumn } = config
  const { q = '', perPage = 10, page = 1 } = config

  /*
  const dataAsc = data.kpis_list.sort((a, b) => {
    if (a[sortColumn]) {
      return a[sortColumn] < b[sortColumn] ? -1 : 1
    } else {
      const splitColumn = sortColumn.split('.')
      const columnA = a[splitColumn[0]][splitColumn[1]]
      const columnB = b[splitColumn[0]][splitColumn[1]]
      return columnA < columnB ? -1 : 1
    }
  })
  */

  const dataToFilter = data.kpis_list //sort === 'asc' ? dataAsc : dataAsc.reverse()

  const queryLowered = q.toLowerCase()
  const filteredData = dataToFilter.filter(item => {

      return (
        (
          item.nombre.toLowerCase().includes(queryLowered)
        )
      )
  })

  return [
    200,
    {
      allData   : data.kpis_list,
      total     : filteredData.length,
      kpis_list : filteredData.length <= perPage ? filteredData : paginateArray(filteredData, perPage, page),
      dataFiltered: filteredData
    }
  ]  
}

// ------------------------------------------------
// GET: Return closure List for Comission
// ------------------------------------------------
let dataKpisDetail = JSON.parse(localStorage.getItem("dataKpisDetail")) || { kpis_list: [], date_from: '', date_to: ''}

mock.onGet('/apps/kpisdetail/list').reply(async config => {

  const user = getUserData()

  const body = {
    user      : config.user_select,
    date_from : config.startDate,
    date_to   : config.endDate
  }

  if (localStorage.getItem("resetKpisDetail")) {
    if (localStorage.getItem("resetKpisDetail") === "true") {
      config.reset = true
    }

    localStorage.removeItem("resetKpisDetail")
  }

  const now = new Date()
  const diffInMinutes = (now - dataKpisDetail.last) / (1000 * 60)

  if (diffInMinutes >= 5) {
    config.reset = true
  }

  if (config.reset) {
    dataKpisDetail = { kpis_list: [], date_from: '', date_to: '' }
  }

  const result = await getKpisList(dataKpisDetail, 1, GetApiCOC('getKpisInfoUser'), user.token, body, config)

  dataKpisDetail = { kpis_list: result[1].allData, date_from: config.startDate, date_to: config.endDate }

  localStorage.setItem("dataKpisDetail", JSON.stringify(dataKpisDetail))

  return result
})
